import { interpolate } from "remotion"

export type MotionPreset = "zoom_in" | "zoom_out" | "pan_left" | "pan_right" | "none"

/**
 * Get scale and translate values for a Ken Burns effect based on the motion preset.
 * Returns { scale, translateX, translateY } for the given frame within a segment.
 */
export function getKenBurnsTransform(
  motion: MotionPreset,
  frame: number,
  durationInFrames: number,
): { scale: number; translateX: number; translateY: number } {
  if (motion === "none" || durationInFrames <= 0) {
    return { scale: 1, translateX: 0, translateY: 0 }
  }

  const progress = Math.min(frame / Math.max(durationInFrames, 1), 1)

  switch (motion) {
    case "zoom_in":
      return {
        scale: interpolate(progress, [0, 1], [1, 1.2]),
        translateX: 0,
        translateY: 0,
      }
    case "zoom_out":
      return {
        scale: interpolate(progress, [0, 1], [1.2, 1]),
        translateX: 0,
        translateY: 0,
      }
    case "pan_left":
      return {
        scale: 1.1,
        translateX: interpolate(progress, [0, 1], [5, -5]),
        translateY: 0,
      }
    case "pan_right":
      return {
        scale: 1.1,
        translateX: interpolate(progress, [0, 1], [-5, 5]),
        translateY: 0,
      }
    default:
      return { scale: 1, translateX: 0, translateY: 0 }
  }
}
